/**
 * MAĞAZA TİPLERİ — F-GAM-16, oyunlaştırma dalga 2 / sürüm 7a.
 *
 * Tek kaynak SUNUCU SÖZLEŞMESİ: `packages/contracts/src/oyun-magaza.ts`. Bu dosya yalnız ekranların alıştığı adları
 * sözleşme tiplerine bağlar ve öğrenci diliyle yazılmış etiketleri taşır; alan TANIMLAMAZ.
 *
 * Bütün sayılar ve durumlar SUNUCUDAN: ekran fiyat, stok, bakiye yeterliliği ya da 18 yaş kararı HESAPLAMAZ.
 */
import type { SiparisIptalNedeni, SiparisOzeti, UrunVitrinOzeti } from "@koclukpanel/contracts";

export type {
  MagazaVitrini,
  SiparisAdresi,
  SiparisDurumu,
  SiparisIptalNedeni,
  VeliKararYaniti,
  VeliSiparisOnayi,
} from "@koclukpanel/contracts";
export { SIPARIS_DURUMU_ETIKETI } from "@koclukpanel/contracts";

/** Vitrindeki ürün (sözleşme `UrunVitrinOzeti`). */
export type MagazaUrunu = UrunVitrinOzeti;

/** Öğrencinin kendi siparişi (sözleşme `SiparisOzeti`). ADRES hiçbir zaman dönmez; yalnız `adresVerildi`. */
export type Siparis = SiparisOzeti;

/**
 * Öğrenciye konuşan iptal etiketleri. Teslim edilemeyen siparişte de puan AYNI işlemde iade edilir (S6, sunucu).
 */
export const SIPARIS_IPTAL_NEDENI_ETIKETI: Record<SiparisIptalNedeni, string> = {
  STUDENT: "Sen iptal ettin",
  PARENT_REJECTED: "Velin onaylamadı",
  PARENT_TIMEOUT: "Onay süresi doldu",
  ADMIN: "Kurum iptal etti",
  UNDELIVERABLE: "Teslim edilemedi",
};
